import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-second-opinion-international',
    templateUrl: './second-opinion-international.component.html',
    styleUrls: ['../second-opinion-fr/second-opinion-fr.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SecondOpinionInternationalComponent {
  readonly secondOpinionUrl = 'https://secondopinion.gustaveroussy.fr';
}
